import { render, staticRenderFns } from "./ReleaseNotesView.vue?vue&type=template&id=8f750e3c&scoped=true&"
import script from "./ReleaseNotesView.vue?vue&type=script&lang=js&"
export * from "./ReleaseNotesView.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseNotesView.vue?vue&type=style&index=0&id=8f750e3c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f750e3c",
  null
  
)

export default component.exports